<template>
  <v-dialog persistent v-model="show">
    <v-card class="mt-2">
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px; padding-top: 16px"
      >
        <span class="headline mb-0">詳細情報</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save" class="mr-2" v-permit.SHARP_DIM_HOLD>{{
          $t('app.buttons.save')
        }}</v-btn>
        <v-btn @click="initInfo" class="ml-2">{{
          $t('app.buttons.back')
        }}</v-btn>
        <v-btn @click="getDeliveryDirectors" class="ml-2">納入指示者取得</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                label="D/O NO(親)"
                v-model="order.doNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                disabled
                label="フライトNO"
                v-if="order.isAir"
                v-model="order.volNo"
              ></v-text-field>
              <v-text-field
                disabled
                label="本船"
                v-else
                v-model="order.shipName"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.volNo')"
                v-model="order.volNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.etd')"
                v-model="order.etd"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.loadingPort')"
                v-model="order.loadingPortName"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.dischargePort')"
                v-model="order.dischargePortName"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.transportMode')"
                v-model="order.transportModeCode"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.eta')"
                v-model="order.eta"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-autocomplete
                :disabled="order.status == '指示Mail送信済'"
                :items="employees"
                clearable
                label="納入指示者"
                persistent-hint
                returnObject
                v-model="newDirector"
              >
                <template slot="append-outer">
                  <v-icon
                    @click="addNewDirector"
                    color="success"
                    v-text="'add'"
                  ></v-icon>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-card>
            <v-chip-group column multiple>
              <v-chip
                :key="chip.id"
                @input="remove(chip)"
                close
                color="orange"
                outline
                v-for="chip in chips"
                >{{ chip.text }}</v-chip
              >
            </v-chip-group>
          </v-card>
        </v-container>
      </v-form>

      <v-data-table
        :headers="headers"
        :items="order.packages"
        :rows-per-page-items="[10]"
        class="inline-edit pb-4"
        hide-actions
        item-key="seq"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.doNo }}</td>
          <td>{{ props.item.partnerName }}</td>
          <td>{{ props.item.invoiceNo }}</td>
          <td>{{ props.item.containerNo }}</td>
          <td>{{ props.item.flag }}</td>
          <td>{{ props.item.skuCode }}</td>
          <td>{{ props.item.cartonStartNo }}</td>
          <td>{{ props.item.cartonEndNo }}</td>
          <td>{{ props.item.perCartonQty }}</td>
          <td>{{ props.item.totalQty }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    a: true,
    show: false,
    newDirector: {},
    order: {},
    selected: [],
    headers: [
      { text: 'D/O NO', value: 'doNo', sortable: false },
      { text: '海外取引先', value: 'partnerName', sortable: false },
      { text: 'I/V NO', value: 'invoiceNo', sortable: false },
      { text: 'コンテナNO', value: 'containerNo', sortable: false },
      { text: '識別No.', value: 'flag', sortable: false },
      { text: '品番', value: 'skuCode', sortable: false },
      { text: 'Carton Start', value: 'cartonStartNo', sortable: false },
      { text: 'Carton End', value: 'cartonEndNo', sortable: false },
      { text: '入れ数', value: 'perCartonQty', sortable: false },
      { text: '数量', value: 'totalQty', sortable: false },
    ],
    resolve: null,
    reject: null,
    errors: {
      CAN_NOT_RESET: '担当者を再度設定できません。',
    },
    directors: {},
    chips: [],
    finalDeliveryDirectors: [],
    employees: [],
  }),
  methods: {
    addNewDirector() {
      if (this.newDirector.value == null) {
        this.$message('', '納入指示者がブランクできません。')
      } else if (this.findSameEmployee()) {
        this.$message('', '該当納入指示者が既に存在しています。')
      } else {
        this.chips = [
          ...this.chips,
          { text: this.newDirector.text, value: this.newDirector.value },
        ]
        this.finalDeliveryDirectors = [
          ...this.finalDeliveryDirectors,
          {
            id: this.newDirector.value,
          },
        ]
      }
    },
    findSameEmployee() {
      for (var i = 0; i < this.finalDeliveryDirectors.length; i++) {
        if (this.finalDeliveryDirectors[i].id === this.newDirector.value) {
          return true
        }
      }
      return false
    },
    remove(item) {
      this.$confirm({ content: '削除してよろしいでしょうか？' }).then(() => {
        console.log(item)
        this.chips.forEach((c, index) => {
          if (c.value === item.value) {
            this.chips.splice(index, 1)
          }
        })
        this.finalDeliveryDirectors.forEach((c, index) => {
          if (c.id === item.value) {
            this.finalDeliveryDirectors.splice(index, 1)
          }
        })
      })
    },
    getDeliveryDirectors() {
      this.$http
        .put(`/shipping-advices/reset-delivery-directors/${this.order.id}`)
        .then(() => {
          this.$message('', 'success')
          this.$http.get(`/shipping-advices/${this.order.id}`).then((res) => {
            this.order = res.data
            this.order.packages.forEach((o) => {
              o.doNo = this.order.doNo
              o.partnerName = this.order.partnerName
            })
          })
          this.initInfo()
        })
        .catch((res) => {
          this.$showError(res)
        })
    },
    initInfo() {
      this.finalDeliveryDirectors = []
      this.directors = {}
      this.newDirector = {}
      this.chips = []
      this.show = false

      this.$emit('refresh')
    },
    popup(id) {
      return this.$http.get(`/shipping-advices/${id}`).then((res) => {
        this.order = res.data
        this.order.packages.forEach((o) => {
          o.doNo = this.order.doNo
          o.partnerName = this.order.partnerName
        })

        this.order.directors.forEach((d) => {
          this.chips = [
            ...this.chips,
            {
              text: d.fullName + ':' + d.email,
              value: d.id,
            },
          ]
        })

        this.finalDeliveryDirectors = this.order.directors

        this.show = true
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      })
    },
    save() {
      return this.$http
        .put(
          `shipping-advices/${this.order.id}/set-delivery-director`,
          this.finalDeliveryDirectors
        )
        .then(() => {
          this.$message('', '保存が完了しました。')
          this.initInfo()
        })
    },
  },
  mounted() {
    this.$http.get('employees/email-kv').then((res) => {
      res.data.forEach((d) => {
        this.employees = [...this.employees, d]
      })
    })
  },
}
</script>
